/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseSuccessResponseData,
    PressReleaseSuccessResponseDataFromJSON,
    PressReleaseSuccessResponseDataFromJSONTyped,
    PressReleaseSuccessResponseDataToJSON,
} from './PressReleaseSuccessResponseData';

/**
 * PUT /press_release/{release_id}
 * @export
 * @interface UpdatePressReleaseResponse
 */
export interface UpdatePressReleaseResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdatePressReleaseResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePressReleaseResponse
     */
    message: string;
    /**
     * 
     * @type {PressReleaseSuccessResponseData}
     * @memberof UpdatePressReleaseResponse
     */
    data: PressReleaseSuccessResponseData;
}

export function UpdatePressReleaseResponseFromJSON(json: any): UpdatePressReleaseResponse {
    return UpdatePressReleaseResponseFromJSONTyped(json, false);
}

export function UpdatePressReleaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePressReleaseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressReleaseSuccessResponseDataFromJSON(json['data']),
    };
}

export function UpdatePressReleaseResponseToJSON(value?: UpdatePressReleaseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressReleaseSuccessResponseDataToJSON(value.data),
    };
}

